<template>
  <label class="checkbox-box" :class="innerVal.indexOf(label) > -1 ? 'is-checked' : ''">
    <div class="checkbox-inside" :class="disabled == true ? 'disabled' : ''">
      <div class="checkbox-warp">
        <input v-model="innerVal" class="checkbox" type="checkbox" :disabled="disabled" :value="label" :name="name" @change="changeCheckbox">
        <i class="icons checkbox-icon" />
      </div>
      <span v-show="text" class="hidden ac textover ml5 " :class="disabled == true ? 'disabled' : ''" v-html="text" />
    </div>
  </label>
  <!-- <div class="input-father checkbox-group">
      <label class="checkbox-box" style="width: 125px;" v-for="(item,index) in schemeList" :key="index">
          <label class="checkbox-warp fl" :class="schem.indexOf(item.name)  != -1? 'curr' : ''">
            <input name="" v-model="schem" type="checkbox" :value="item.name" class="checkbox">
            <i class="icons checkbox-icon"></i>
          </label>
          <div class="hidden ac textover" :title="item.name">{{item.name}}</div>
      </label>
  </div> -->
</template>

<script>
export default {
  props: {
    value: null,
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String
    },
    name: {
      type: String
    },
    label: {
      type: String | Number
    }
  },
  data() {
    return {

    }
  },
  computed: {
    innerVal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  // 渲染到页面的时候
  mounted() {

  },
  methods: {
    changeCheckbox() {
      this.$emit('change')
    }
  }
}
</script>

<style scoped>
    .checkbox-warp{display:flex;align-items:center;cursor:pointer;margin: 0;}
    .checkbox-inside{display:flex;align-items:center;}
    .checkbox{width:16px;height:16px;display:flex;align-content:center;justify-content:center;overflow:hidden;}
    .checkbox input{position:absolute;top:0;left:0;opacity:0;width:100%;height:100%;cursor:pointer;}
    .checkbox input[type="checkbox"] + .iconfont{border-radius:2px;}
    .checkbox .iconfont{width:100%;height:100%;display:flex;align-items:center;justify-content:center;border:1px solid #dcdfe6;}
    .checkbox-warp.is-checked .checkbox .iconfont{background:#409eff;border:#409eff;color:#fff;}
    .checkbox-warp.is-checked .checkbox .iconfont:before{content:'\e64d';font-family:'iconfont';font-size:12px;}
    .checkbox-warp.is-checked .check-text{color:#409eff;}
    .checkbox-warp .disabled .iconfont{background:#ddd;}
    .checkbox-warp.is-checked .disabled .iconfont{background:#ddd;}
    .checkbox-warp.is-checked .disabled .iconfont:before{color:#c0c4cc;}
    .checkbox-block .checkbox-warp.is-checked .checkbox-inside{background:#e5f0ff;border:1px solid #e5f0ff;}
    .checkbox-block .checkbox-warp .checkbox-inside.disabled{background:#eee;border:1px solid #eee;}
    .checkbox-warp .check-text.disabled{color:#c0c4cc;}
</style>



// WEBPACK FOOTER //
// src/components/checkbox.vue